import Navbar from '../NavBar/Navbar'


const Header = () => {
    return (
        <header>
            <Navbar />
        </header>
    )
}

export default Header
